import React, { useEffect, useState } from 'react'
import { portal } from '../portalApi.js'
import { fmt } from '../api.js'

// 서랍(메모) 현황 — 대상별로 몇 건 쌓였는지 세는 화면
export default function NoteStats({ targetLabels }) {
  const [data, setData] = useState(null)
  const [err, setErr] = useState('')

  useEffect(() => {
    portal.get('/api/notes/stats').then(setData).catch((e) => setErr(e.message))
  }, [])

  return (
    <>
      <h2>서랍(메모) 현황</h2>
      {err && <div className="error-box">{err}</div>}
      {!err && !data && <div className="muted">불러오는 중…</div>}
      {data && (
        <div className="panel">
          <h3>전체 {fmt(data.total)}건</h3>
          <table style={{ maxWidth: 480 }}>
            <thead><tr><th className="l">화면</th><th>메모(답글 포함) 건수</th></tr></thead>
            <tbody>
              {data.byTarget.length === 0 && <tr><td colSpan={2} className="c muted">아직 메모가 없습니다</td></tr>}
              {data.byTarget.map((row) => (
                <tr key={row.target}>
                  <td className="l">{(targetLabels && targetLabels[row.target]) || row.target}</td>
                  <td>{fmt(row.n)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}
